import React from 'react';
import { khachHangSearchColumns, khuVucSearchColumns, nhomColumns, QUERY_KEYS } from '@/constants';
import { FormFieldV2, SearchFieldV2 as SearchField } from '@/components/custom/erp';
import { Label } from '@/components/ui/label';

interface Props {
  formMode: 'add' | 'edit' | 'view';
}

const DetailTab = ({ formMode }: Props) => {
  return (
    <div className='space-y-4 p-4'>
      {/* Mã khách hàng */}
      <div className='flex items-center gap-x-4'>
        <Label className='min-w-[150px] text-sm font-normal'>Mã khách hàng</Label>
        <div className='flex-1'>
          <SearchField
            disabled={formMode === 'view'}
            searchEndpoint={`/${QUERY_KEYS.KHACH_HANG}/`}
            searchColumns={khachHangSearchColumns}
            dialogTitle='Danh mục khách hàng'
            columnDisplay='customer_code'
            displayRelatedField='customer_name'
            name='ma_kh'
            className='w-fit'
          />
        </div>
      </div>

      {/* Nhóm khách hàng */}
      <div className='flex items-center gap-x-4'>
        <Label className='min-w-[150px] text-sm font-normal'>Nhóm khách hàng</Label>
        <div className='flex flex-1 gap-x-2'>
          <SearchField
            disabled={formMode === 'view'}
            searchEndpoint={`/${QUERY_KEYS.NHOM}/?loai_nhom=NCC1`}
            searchColumns={nhomColumns}
            dialogTitle='Danh mục nhóm khách hàng 1'
            columnDisplay='ma_nhom'
            name='nh_kh1'
            className='w-fit'
          />
          <SearchField
            disabled={formMode === 'view'}
            searchEndpoint={`/${QUERY_KEYS.NHOM}/?loai_nhom=NCC2`}
            searchColumns={nhomColumns}
            dialogTitle='Danh mục nhóm khách hàng 2'
            columnDisplay='ma_nhom'
            name='nh_kh2'
            className='w-fit'
          />
          <SearchField
            disabled={formMode === 'view'}
            searchEndpoint={`/${QUERY_KEYS.NHOM}/?loai_nhom=NCC3`}
            searchColumns={nhomColumns}
            dialogTitle='Danh mục nhóm khách hàng 3'
            columnDisplay='ma_nhom'
            name='nh_kh3'
            className='w-fit'
          />
        </div>
      </div>

      {/* Khu vực */}
      <div className='flex items-center gap-x-4'>
        <Label className='min-w-[150px] text-sm font-normal'>Khu vực</Label>
        <div className='flex-1'>
          <SearchField
            disabled={formMode === 'view'}
            searchEndpoint={`/${QUERY_KEYS.KHU_VUC}/`}
            searchColumns={khuVucSearchColumns}
            dialogTitle='Danh mục khu vực'
            columnDisplay='rg_code'
            displayRelatedField='rgname'
            name='rg_code'
            className='w-fit'
          />
        </div>
      </div>

      {/* Tất toán */}
      <div className='flex items-center gap-x-4'>
        <Label className='min-w-[150px] text-sm font-normal'>Tất toán</Label>
        <div>
          <FormFieldV2
            name='tat_toan'
            type='select'
            disabled={formMode === 'view'}
            options={[
              { label: 'Chưa tất toán', value: '1' },
              { label: 'Đã tất toán sử dụng tính năng này', value: '2' }
            ]}
          />
        </div>
      </div>

      {/* Mẫu báo cáo */}
      <div className='flex items-center gap-x-4'>
        <Label className='min-w-[150px] text-sm font-normal'>Mẫu báo cáo</Label>
        <div>
          <FormFieldV2
            name='mau_bao_cao'
            type='select'
            disabled={formMode === 'view'}
            options={[
              { label: 'Mẫu tiền chuẩn', value: '1' },
              { label: 'Mẫu ngoại tệ', value: '2' }
            ]}
          />
        </div>
      </div>
    </div>
  );
};

export default DetailTab;
